export const firebaseConfig = {
  apiKey: "AIzaSyDSZP9xWzn4xhsMCgjisokaZJhUQPa7S3s",
  authDomain: "parking-f930a.firebaseapp.com",
  databaseURL: "https://parking-f930a.firebaseio.com",
  projectId: "parking-f930a",
  storageBucket: "parking-f930a.appspot.com",
  messagingSenderId: "600209324981",
  appId: "1:600209324981:web:6c4f64986b7dec718077fc"
  };